<template>
  <div class="content">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :immediate-check="false"
    >
      <div
        class="list"
        v-for="(item, index) in list"
        :key="index"
        @click="goDetail(item.id)"
      >
        <div class="card-title">
         
          <span>订单编号：{{item.orderSn}}</span>
          <span style="color: #ee0a24">{{
            item.afterSaleType ? '退货退款' : '退款'
          }}</span>
        </div>
        <div class="card">
          <img :src="item.productPictureUrl" alt="" />
          <div>
            <p class="van-multi-ellipsis--l2">
              {{ item.title }}
            </p>
            <p>数量：{{ item.productQuantity }}</p>
          </div>
        </div>
        <!-- <div class="card-status">
        <div class="status">待审核</div>
        <div>
          <p>您的服务单已申请成功，待售后审核中</p>
          <p>
            预计 <span style="color: #ee0a24">01小时39分51秒</span> 内为您审核
          </p>
        </div>
        <van-icon name="arrow" />
      </div> -->
        <!-- <div class="card-status">
          <div class="status">服务单取消</div>
          <div>
            <p>服务已取消，如有需要可在售后</p>
            <p>申请页面重新提交服务单</p>
          </div>
          <van-icon name="arrow" />
        </div> -->
        <!-- <div class="card-status">
          <div class="status">服务单关闭</div>
          <div>
            <p>服务已关闭，感谢您的支持</p>
          </div>
          <van-icon name="arrow" />
        </div> -->
        <div class="card-btn">
          <van-button
            round
            size="small"
            @click.stop="cancel(item.id)"
            v-if="item.status !== 6 && item.status !== 4 && item.status !== 5 && item.status !== 3"
            >取消申请</van-button
          >
          <van-button round size="small">查看详情</van-button>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { processingList, cancelApply } from '@/api/after-sale'

export default {
  data() {
    return {
      list: [],
      finished: false,
      loading: false,
      query: {
        current: 1,
        size: 10,
        keyword: undefined,
      },
    }
  },
  created() {
    this.onLoad()
  },
  methods: {
    onLoad() {
      // 异步更新数据
      this.loading = true
      processingList(this.query).then(({ data }) => {
        if (data.code === 200) {
          const total = data.data.total
          this.list = this.list.concat(data.data.records)
          // 加载状态结束

          this.query.current++
          this.loading = false
          console.log('this.list', this.list)
          // 数据全部加载完成
          if (this.list.length >= total) {
            this.finished = true
          }

          // if (this.list.length === 0) {
          //   this.finishedText = ''
          // }
        }
      })
    },
    cancel(id) {
      this.$dialog
        .confirm({
          title: '取消申请',
          message: '是否取消申请退款',
        })
        .then(() => {
          const toast = this.$toast.loading({
            message: '提交中',
            forbidClick: true,
            loadingType: 'spinner',
            duration: 0,
          })
          cancelApply(id)
            .then(({ data }) => {
              if (data.code === 200) {
                this.list = []
                this.onLoad()
                this.$toast('取消申请成功')
              }
            })
            .finally(() => {
              toast.clear()
            })
        })
        .catch(() => {
          // on cancel
        })
    },
    goDetail(id) {
      this.$router.push({
        path: '/after-sale/detail',
        query: { id: id },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.container {
  color: #646566;
  min-height: 100vh;
  background: rgb(246, 246, 246);
}
.list {
  background: #fff;
  // margin-top: 10px;
  border-top: 10px solid rgb(246, 246, 246);
  padding: 10px;
  .card-title {
    padding: 0px 15px 10px 0px;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
  }
  .card {
    display: flex;
    p {
      font-size: 14px;
      margin: 0 0 10px 0;
    }
    img {
      width: 80px;
      height: 80px;
      border-radius: 5px;
      margin-right: 10px;
    }
  }
  .card-status {
    min-height: 55px;
    justify-content: space-between;
    border-radius: 5px;
    margin-top: 10px;
    display: flex;
    font-size: 14px;
    align-items: center;
    padding: 5px 15px;
    background: rgb(246, 246, 246);
    color: #848484;
    p {
      margin: 2.5px 0;
    }
    /deep/.van-icon {
      color: #848484;
      font-size: 20px;
    }
    .status {
      margin-right: 15px;
    }
  }
  .card-btn {
    display: flex;
    justify-content: flex-end;
    padding: 10px 5px 0px 0px;
    /deep/ .van-button--round {
      margin-right: 15px;
      border-color: #ee0a24;
      /deep/.van-button__text {
        color: #ee0a24;
      }
    }
    span {
      font-size: 12px;
      color: #848484;
    }
  }
  .line {
    margin: 0px 15px 10px 15px;
    height: 1px;
    background: rgb(246, 246, 246);
  }
}
</style>